/**
 * Module dependencies.
 */

import { Control } from 'react-hook-form';
import { InputField } from 'src/components/core/forms/input/field';
import { minDateRule, requiredRule } from 'src/core/forms/rules';
import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import addDays from 'date-fns/addDays';
import calendarSvg from 'src/assets/svg/calendar.svg';
import clockSvg from 'src/assets/svg/clock.svg';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  control: Control<any>;
};

/**
 * `TimeDateWrapper` styled component.
 */

const TimeDateWrapper = styled.div`
  display: grid;
  grid-gap: 32px;
  grid-template-columns: 1fr 1fr;

  & > :last-child {
    margin-bottom: 0;
  }
`;

/**
 * Export `DateTimeFields` component.
 */

export function DateTimeFields({ control }: Props) {
  const { t } = useTranslation('common');
  const tomorrowDate = useMemo(() => addDays(new Date(), 1).toISOString(), []);

  return (
    <TimeDateWrapper>
      <InputField
        control={control}
        icon={calendarSvg}
        iconType={'button'}
        isRequired
        label={t('common:form.labels.date')}
        name={'date'}
        rules={{
          ...requiredRule(t),
          ...minDateRule(tomorrowDate, t)
        }}
        type={'date'}
      />

      <InputField
        control={control}
        icon={clockSvg}
        iconType={'button'}
        isRequired
        label={t('common:form.labels.time')}
        name={'time'}
        rules={requiredRule(t)}
        type={'time'}
      />
    </TimeDateWrapper>
  );
}
